<template>
    <section class="colorlib-services" data-section="services">
        <div class="colorlib-narrow-content">
            <div class="row">
                <div class="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                    <span class="heading-meta">What I do?</span>
                    <h2 class="colorlib-heading">Here are some of my expertise</h2>
                </div>
            </div>
            <div class="row row-pt-md">
                <div class="col-md-4 text-center animate-box">
                    <div class="services color-1">
                        <span class="icon">
                            <i class="icon-bulb"></i>
                        </span>
                        <div class="desc">
                            <h3>Web Development</h3>
                            <p>I'm able to build web pages from the zero part and I can make a change to the site that is done by others </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 text-center animate-box">
                    <div class="services color-6">
                        <span class="icon">
                            <i class="icon-data"></i>
                        </span>
                        <div class="desc">
                            <h3>Responsive and Adaptive page</h3>
                            <p>I can build responsive as well as adaptive web pages that automatically resize, hide, shrink, or enlarge, a website, to make it look good on all devices (desktops, tablets, and phones)</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default{
        name: "Service"
    }
</script>